import { observable, action, computed, reaction } from 'mobx';
import {Collection, Document} from 'firestorter';
// n.b: firestorter lacks pagination today,
// but implementation of pagination will soon come,
// it should so in time to handle a rising quantity of data

class UserStore {
  // users = new Collection('users', {realtimeUpdating: 'on'});

  @observable pendingNurses = new Collection('users', {mode: 'on'});
  @observable Patients = new Collection('users', {mode: 'on'});
  users = new Collection('users', {mode: 'on'});
  requests = new Collection('requests');
  contracts = new Collection('contracts');
  zip = new Collection('zipCodes');
  transactions = new Collection('transactions');
  
  constructor(Store) {
    this.Store = Store;
  }

  // @computed get userFormat() {
    // return this.users.map((doc, i) => ({
    //         key: i,
    //         firstname: doc.data.firstname,
    //         lastname: doc.data.lastname,
    //         city: doc.data.city,
    //         role: doc.data.role,
    //         uid: doc.id,
    //         doc: doc
    //       }));
  // }
  // loading = reaction(() => usersCollection.fetching, fetching => console.log('FETCHING:', fetching));

  // @action setUsers = users => {
  //   this.users = users;
  // }
}

export default UserStore;



// WEBPACK FOOTER //
// ./src/stores/userStore.js